
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  --layout-gap:var(
    --sic-simple-feature--layout-gap,
    var(--sic-simple-feature--default--layout-gap)
  );
  --border-radius:var(
    --sic-simple-feature--border-radius,
    var(--sic-simple-feature--default--border-radius)
  );
  --margin-to-edge:calc(100% - 50vw + calc(var(--layout-gap) / 2));
  display:block;
}

.simple-feature-wrapper{
  display:grid;
  grid-template-columns:var(--sic-simple-feature--default--grid-template-colums);
  grid-template-columns:var(
    --sic-simple-feature--grid-template-colums,
    var(--sic-simple-feature--default--grid-template-colums)
  );
  grid-template-rows:1fr;
  grid-column-gap:var(--layout-gap);
  grid-row-gap:0px;
  align-items:center;
}

.media-layout{
  display:flex;
  height:100%;
  margin-right:var(--margin-to-edge);
  padding-left:var(--layout-gap);
}

@media (min-width: 1920px){

.media-layout{
    margin-right:0
}
  }

.layout-negative-magrin-mobile.layout-stacked{
  margin-top:calc(var(--container-py-normal) * -1);
  margin-bottom:calc(var(--container-py-normal) * -1);
}

.image-container{
  display:flex;
  width:100%;
  max-width:var(--sic-simple-feature--default--image-max-width);
  max-width:var(
    --sic-simple-feature--image-max-width,
    var(--sic-simple-feature--default--image-max-width)
  );
  margin-left:auto;
}

.image-container .image,
  .image-container .image > div{
    display:flex;
    height:100%;
    width:100%;
  }

.body{
  font-size:var(--sic-simple-feature--default--font-size);
  font-size:var(
    --sic-simple-feature--font-size,
    var(--sic-simple-feature--default--font-size)
  );
  line-height:var(--sic-simple-feature--default--line-height);
  line-height:var(
    --sic-simple-feature--line-height,
    var(--sic-simple-feature--default--line-height)
  );
  margin-top:var(--sic-simple-feature--default--body-top-spacing);
  margin-top:var(
    --sic-simple-feature--body-top-spacing,
    var(--sic-simple-feature--default--body-top-spacing)
  );
  color:var(--sic-text-color);
  font-weight:400;
}

.cta-wrapper{
  display:flex;
  flex-direction:column;
}

.cta{
  margin-top:var(--sic-simple-feature--default--cta-top-spacing);
  margin-top:var(
    --sic-simple-feature--cta-top-spacing,
    var(--sic-simple-feature--default--cta-top-spacing)
  );
}

.cta2{
  margin-top:var(--sic-simple-feature--default--cta-top-spacing);
  margin-top:var(
    --sic-simple-feature--cta-top-spacing,
    var(--sic-simple-feature--default--cta-top-spacing)
  );
}

.layout-media-first .media-layout{
    margin-right:0;
    margin-left:var(--margin-to-edge);
    padding-left:0;
    padding-right:var(--layout-gap);
  }

@media (min-width: 1920px){

.layout-media-first .media-layout{
      margin-left:0
  }
    }

.layout-media-first .image-container{
    margin-left:unset;
  }

.layout-stacked{
  display:block;
  padding-block:0;
}

.layout-stacked .content-layout{
    padding-block:var(--sic-simple-feature--default--padding-block--stacked);
    padding-block:var(
      --sic-simple-feature--padding-block--stacked,
      var(--sic-simple-feature--default--padding-block--stacked)
    );
    width:100%;
  }

.layout-stacked .media-layout{
    width:100vw;
    margin-left:calc(-1 * var(--container-px-normal));
    margin-right:calc(-1 * var(--container-px-normal));
    padding:0;
  }

.layout-stacked .cta{
    margin-top:var(--sic-simple-feature--default--cta-top-spacing--stacked);
    margin-top:var(
      --sic-simple-feature--cta-top-spacing--stacked,
      var(--sic-simple-feature--default--cta-top-spacing--stacked)
    );
  }

.layout-stacked .cta .btn{
      width:100%;
    }

.layout-stacked .image-container{
    border-radius:0;
    display:block;
    margin-right:auto;
  }
`;